import { useQuery } from '../../../hook/use-query'
import { authService } from '../../../service/auth-service'
import { logger } from '../../../util/logger'
import { ErrorMessageHint } from '../../util/error-message-hint'
import { OverlaySpinner } from '../../util/spinner/overlay-spinner'
import style from './forgot-password.module.scss'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import * as yup from 'yup'

type FormValues = {
  email: string
}

const requestForgotPasswordSchema = yup
  .object()
  .shape({
    email: yup.string().email('Please enter a valid email address').trim().required('Email is required.'),
  })
  .required()

export const RequestForgotPasswordStep = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const history = useHistory()
  const query = useQuery()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(requestForgotPasswordSchema),
    defaultValues: { email: query.get('email') || '' },
  })

  const onSubmit = async (data: FormValues): Promise<void> => {
    try {
      if (setIsLoading) setIsLoading(true)
      setErrorMessage(undefined)
      const { email } = data
      await authService.requestResetPassword({ email })
      history.push(`/forgot-password/verify-email/${email}`)
    } catch (err: any) {
      logger.error(err)
      setErrorMessage(err.message)
    } finally {
      if (setIsLoading) setIsLoading(false)
    }
  }

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <h1 className="text-center">Enter your email address</h1>
        <Form.Group className={style.inputContainerGroup}>
          <Form.Group>
            <Form.Control
              type="text"
              placeholder="Email"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              {...register('email')}
            />
            <Form.Control.Feedback type="invalid">{errors.email && <p>{errors.email.message}</p>}</Form.Control.Feedback>
          </Form.Group>
          <ErrorMessageHint message={errorMessage} />
        </Form.Group>
        <Form.Group className="form-group">
          <Button type="submit" className="w-100">
            Continue
          </Button>
          <div className="text-secondary text-center">
            You remembered you password?{' '}
            <strong>
              <u>
                <Link className="text-secondary" to="/login">
                  Login
                </Link>
              </u>
            </strong>
          </div>
        </Form.Group>
      </Form>
      {isLoading && <OverlaySpinner />}
    </>
  )
}
